export function useTranslation() {
  const transData = useState<{ [key in string]: string }>('translation', () => ({}))

  /**
   * 다국어 데이터 세팅
   */
  async function update(languageGbSn: string) {
    transData.value = await fetch(languageGbSn)
  }

  async function fetch(languageGbSn: string): Promise<{ [x: string]: string }> {
    const data: { [key in string]: string } = await $fetch('https://napi.watv.org/trans/v2', {
      method: 'GET',
      query: {
        projectId: 95,
        languageGbSn,
        tagIds: [236, 87, 310, 329, 332],
      },
    })

    return data
  }

  /**
   *
   * @param key 다국어 키
   * @param params 번역문 안의 `{이름}` 자리에 넣을 값. (예: `$t('...{no}호', { no: 1 })`)
   * @returns 다국어 Value
   */
  function $t(key: string, params?: Record<string, string | number>) {
    const text = transData.value[key] ?? ''
    if (!params) {
      return text
    }

    return Object.entries(params).reduce(
      (acc, [name, value]) => acc.replaceAll(`{${name}}`, String(value)),
      text,
    )
  }

  return { transData, $t, update, fetch }
}
